import { render, staticRenderFns } from "./category-card.vue?vue&type=template&id=02931eb1&"
import script from "./category-card.vue?vue&type=script&lang=js&"
export * from "./category-card.vue?vue&type=script&lang=js&"
import style0 from "./category-card.vue?vue&type=style&index=0&id=02931eb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports